import { render, staticRenderFns } from "./ReferencesPage.vue?vue&type=template&id=06b1c1f8"
import script from "./ReferencesPage.vue?vue&type=script&lang=js"
export * from "./ReferencesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports